import { compose, isEmpty, when } from 'ramda';

import { clear, unprefix } from '../../../../helpers/compact';
import { toText } from '../../fields/text';

export const valueLabelDesc = (prop) =>
  compose(
    when(isEmpty, () => undefined),
    clear,
    ({ value, label, description }) => ({
      value: toText(value),
      label: toText(label),
      description: toText(description),
    }),
    unprefix(prop)
  );
